/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path login
 * @description Login component
 *
 * @section 4.1.2
 *
 */
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import React from "react";
import LoginForm from "./../pages/LoginForm";
import { makeThemedStyles } from "./../viewcomponents/utils";
const containerStyles = makeThemedStyles("Login.Container", (theme) => ({
  root: {},
}));
const qprStyles = makeThemedStyles("Login.FormPaper", (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));
// const qprFormStyles = makeStyles(theme => ({
const qprFormStyles = makeThemedStyles("Login.Form", (theme) => ({
  form: {
    width: "100%",
    padding: theme.spacing(3, 0, 4, 0),
  },
  submit: {
    margin: theme.spacing(1, 0, 0, 0),
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    marginTop: "20px",
  },
  inputRoot: {
    backgroundColor: "#f3f4f5",
    "&$focused": {
      '& [class*="MuiSvgIcon-root"]': {
        color: theme.palette.primary.dark,
      },
    },
    "&$error": {
      '& [class*="MuiSvgIcon-root"]': {
        color: "red",
      },
    },
  },
  focused: {},
  error: {},
  outline: {},
}));
interface QprLogin {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  errorMessage?: string;
}
const Login = ({ handleSubmit, errorMessage = "" }: QprLogin) => {
  const formClasses = qprFormStyles();
  const classes = qprStyles();
  const containerStyle = containerStyles();
  return (
    <Container
      component="main"
      maxWidth="xs"
      data-testid="login-main"
      classes={{ root: containerStyle.root }}
    >
      <Paper className={classes.paper}>
        <LoginForm
          classes={formClasses}
          handleSubmit={handleSubmit}
          errorMessage={errorMessage}
          data-testid="login-form"
        />
      </Paper>
    </Container>
  );
};
export default Login;
